/**
 * Instellingen die bij dít apparaat horen, niet bij het account.
 *
 * Net als het push-abonnement (dat apparaatgebonden is) leven deze
 * schakelaars in localStorage: JP's eigen Mac mag ingelogd blijven en
 * geluid geven, een gedeelde balie-Mac niet. Ze reizen dus bewust niet
 * mee naar een ander toestel.
 *
 * Alle lezen en schrijven gaat door try/catch: in private mode of bij
 * een volle quota gooit localStorage, en dan moet het portaal gewoon
 * op de standaardwaarde terugvallen.
 */

/** Vertrouwd apparaat: sla de idle-logout van 30 minuten hier over. */
export const VERTROUWD_APPARAAT_KEY = "ks.vertrouwdApparaat";
/** Geluid bij nieuwe chat, WhatsApp of mail die actie vraagt. */
export const PORTAAL_GELUID_KEY = "ks.portaalGeluid";
/** Volume van dat geluid, 0..100 (sessie 4). */
export const PORTAAL_VOLUME_KEY = "ks.portaalVolume";

/** Standaardvolume: duidelijk hoorbaar, niet schrikbarend. */
export const PORTAAL_VOLUME_STANDAARD = 70;

function lees(sleutel: string, standaard: boolean): boolean {
  try {
    const raw = window.localStorage.getItem(sleutel);
    if (raw === null) return standaard;
    return raw === "1";
  } catch {
    return standaard;
  }
}

function schrijf(sleutel: string, aan: boolean): void {
  try {
    window.localStorage.setItem(sleutel, aan ? "1" : "0");
  } catch {
    /* quota of private mode: de stand geldt dan alleen deze sessie */
  }
}

/** Staat dit apparaat als vertrouwd gemarkeerd? Standaard nee. */
export function isVertrouwdApparaat(): boolean {
  return lees(VERTROUWD_APPARAAT_KEY, false);
}

export function zetVertrouwdApparaat(aan: boolean): void {
  schrijf(VERTROUWD_APPARAAT_KEY, aan);
}

/** Portaalgeluid bij nieuwe items. Standaard aan. */
export function isPortaalGeluidAan(): boolean {
  return lees(PORTAAL_GELUID_KEY, true);
}

export function zetPortaalGeluid(aan: boolean): void {
  schrijf(PORTAAL_GELUID_KEY, aan);
}

/**
 * Volume van de meldingstoon, 0..100. Sessie 4: de oude `/melding.wav`
 * was een vaste, vage piep; de toon wordt nu opgewekt en is dus echt
 * te versterken. Buiten bereik of onleesbaar → de standaardwaarde.
 */
export function haalPortaalVolume(): number {
  try {
    const raw = window.localStorage.getItem(PORTAAL_VOLUME_KEY);
    if (raw === null) return PORTAAL_VOLUME_STANDAARD;
    const waarde = Number.parseInt(raw, 10);
    if (Number.isNaN(waarde)) return PORTAAL_VOLUME_STANDAARD;
    return Math.min(100, Math.max(0, waarde));
  } catch {
    return PORTAAL_VOLUME_STANDAARD;
  }
}

export function zetPortaalVolume(waarde: number): void {
  const begrensd = Math.min(100, Math.max(0, Math.round(waarde)));
  try {
    window.localStorage.setItem(PORTAAL_VOLUME_KEY, String(begrensd));
  } catch {
    /* quota of private mode: de stand geldt dan alleen deze sessie */
  }
}
